package com.milta.core.localization.translations.en

import com.milta.core.localization.ErrorStrings

internal val Errors = ErrorStrings(
    generic = "An error occurred",
    error = "Error",
    fieldRequired = "This field is required",
    invalidEmail = "Invalid email address",
    fileTooLarge = "File too large. Choose a lighter file.",
)
